import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {ID} from '../../../../../../../../_metronic/helpers'
import {schemaOrderLaundryOut} from '../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../central/services'
import {MasiveOut} from '../../../../model'
import {createOutMasive} from '../../../../services'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {InputDateLav} from '../../../../../../components/UI/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getList: () => void
  arrayId: ID[]
  minLength?: any
}

const ModalOut: FC<Props> = ({show, setShow, arrayId, getList, minLength}) => {
  const [typeFurniture, setTypeFurniture] = useState<MasiveOut[] | any>([])
  const methods = useForm<MasiveOut>({
    resolver: yupResolver(schemaOrderLaundryOut),
  })
  const {
    control,
    handleSubmit,
    reset,
    register,
    formState: {errors},
  } = methods
  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarEntrega',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getReceptionPlaceList()
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
  }

  const onSubmit = async (data: MasiveOut) => {
    try {
      let obj = {
        orders: arrayId,
        ...data,
      }

      const {data: res} = await createOutMasive(obj)
      if (!res.error) {
        ShowSnackBar('Se actualizó con exito')
        handleClose()
        getList()
        //mostrar snackbar
      } else {
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {}
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Salida de Ropa de Huésped Masiva</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-6'>
                  <label className='required'>Lugar de salida</label>
                  <Select
                    control={control}
                    name='lugarSalida'
                    data={typeFurniture}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Fecha de salida:</label>
                  <InputDateLav
                    name='fechaSalida'
                    register={register}
                    errors={errors}
                    minValue={minLength}
                  />
                </div>
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalOut}
